// "Stora bilracet" — self-contained arcade widget. These are the game's own
// palette/geometry constants (not theme tokens) since the canvas art can't use
// styled-components and the look is intentionally a fixed arcade aesthetic.

export const GAME_TITLE = 'Stora bilracet';

// Canvas internal resolution (kept fixed; the wrapper scales down on narrow viewports).
export const GAME_CANVAS_WIDTH = 420;
export const GAME_CANVAS_HEIGHT = 560;

export const COLORS = {
  yellow: '#f5b400',
  black: '#1a2030',
  teal: '#2a9d8f',
  coral: '#ef5b5b',
  road: '#232838',
  roadLine: '#3a4060',
  white: '#ffffff',
  green: '#00AA47'
} as const;

// Road / lane geometry (4 lanes).
export const LANE_COUNT = 4;
export const ROAD_LEFT = 60;
export const ROAD_RIGHT = GAME_CANVAS_WIDTH - 60;
export const ROAD_W = ROAD_RIGHT - ROAD_LEFT;
export const LANE_W = ROAD_W / LANE_COUNT;

// Gameplay tuning (ported from source).
export const BASE_SPEED = 3;
export const START_LIVES = 3;
export const HIGH_SCORE_KEY = 'kvdbil_hs';
